import {baseBackendUrl} from "../shared/constants";
import {message} from "antd";

export async function fetchImages() {
    const token = localStorage.getItem('token');
    const imagesResponse = await fetch(`${baseBackendUrl}/welcome/images`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    const imagesData = await imagesResponse.json();
    return imagesData;
}

export async function fetchContent() {
    const token = localStorage.getItem('token');
    const contentResponse = await fetch(`${baseBackendUrl}/welcome/content`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    const contentData = await contentResponse.json();
    return contentData;
}

export async function resendVerification(userEmail) {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${baseBackendUrl}/user/resend-verification`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email: userEmail }),
        });
        if (!response.ok) throw new Error("Ошибка повторной отправки подтверждения");
        message.success("Письмо с подтверждением отправлено!");
    } catch (error) {
        message.error(error.message);
    }
}

export async function verifyEmail(userEmail, verificationCode) {
    const token = localStorage.getItem('token');
    const response = await fetch(`${baseBackendUrl}/user/verify-email`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ email: userEmail, verification_code: verificationCode }),
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.error || "Ошибка подтверждения");
    message.success("Email подтверждён!");
}

export async function uploadImage(formData){
    const token = localStorage.getItem('token');
    const response = await fetch(`${baseBackendUrl}/welcome/upload`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        body: formData,
    });
    if (!response.ok) throw new Error("Ошибка при загрузке");
    message.success("Изображение загружено!");
}

export async function deleteImages(filename){
    const token = localStorage.getItem('token');
    await fetch(`${baseBackendUrl}/welcome/images`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ file: filename }),
    });
    message.success("Изображение удалено!");
}

export async function saveMarkdownContent(markdown){
    const token = localStorage.getItem('token');
    const response = await fetch(`${baseBackendUrl}/welcome/content`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ content: markdown }),
    });
    if (!response.ok) throw new Error("Ошибка при сохранении");
    message.success("Markdown обновлён!");
}